import { SanitizeHTML } from '../globals/SanitizeHTML';
import { useXhr } from '../../hooks/XhrHook';
import './Affluences.css';

const Affluences = ({ content }) => {
  useXhr(`https://webapi.affluences.com/js/webapi_latest.min.js`, 'affluences');

  const removeScript = () => {
    const element = document.getElementById('affluences');
    const css = document.querySelectorAll(
      "link[href='https://static.affluences.media/webapi/css/stylesheet.min.css?hash=9a69f628']"
    );
    const css_length = css.length;
    css.forEach((element, index) => {
      if (index !== css_length - 1) {
        element.remove();
      }
    });
    if (element !== null) {
      if (element.parentNode !== null) {
        element.parentNode.removeChild(element);
      }
    }
  };

  removeScript();

  return (
    <div className="styled-content">
      <SanitizeHTML html={content} />
    </div>
  );
};

export default Affluences;
